import React from 'react';
import { ReactComponent as IconClose } from '../HeaderIcons/close.svg';
import './FeaturePaneHeading.css';

export default function FeaturePaneHeading({ title, closeLabel, onClose }) {
	return <div className="feature-pane-heading">
		<h2>{title}</h2>
		<button type="button" aria-label={closeLabel} onClick={onClose}><IconClose /></button>
	</div>;
}
